import React, { useEffect, useState } from "react";
import { deleteApi, getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi"
import Footer from "../../../Components-2/Footer";
import Header from "../../../Components-2/Header/Header";
import Sidebar1 from "../../../Components-2/Sidebar1";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Modal from 'react-modal';
import Swal from "sweetalert2";
import Select from 'react-select';
import 'react-toggle/style.css';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "./table.css"


function NewPodEntry() {

    const [status, setStatus] = useState([]);
    const [fetched, setFetched] = useState('');
    const [editIndex, setEditIndex] = useState(null);
    const today = new Date();
    const time = String(today.getHours()).padStart(2, "0") + ":" + String(today.getMinutes()).padStart(2, "0");


    const [getCity, setGetCity] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [docket, setDocket] = useState('');
    const [formData, setFormData] = useState({
        toDate: today,
        fromDest: '',
        toDest: '',
        time: time,
        status: "",
    });
    const shipmentStatusOptions = [
    { value: "", label: "Select Shipment Status", isDisabled: true },

    // Booking / Pickup
    { value: "Shipment Booked", label: "Shipment Booked" },
    { value: "Order Created", label: "Order Created" },
    { value: "Shipment Information Received", label: "Shipment Information Received" },
    { value: "Pickup Scheduled", label: "Pickup Scheduled" },
    { value: "Pickup Completed", label: "Pickup Completed" },
    { value: "Collected from Shipper", label: "Collected from Shipper" },
    { value: "Picked up by Purolator", label: "Picked up by Purolator" },

    // Origin Airport / Departure
    {
      value: "Shipment Ready for Departure to Origin Airport",
      label: "Shipment Ready for Departure to Origin Airport",
    },
    { value: "Shipment Departed", label: "Shipment Departed" },
    { value: "Estimated Arrival", label: "Estimated Arrival" },

    // Transit
    { value: "In Transit", label: "In Transit" },
    { value: "Transshipment Hub Arrival", label: "Transshipment Hub Arrival" },
    { value: "Transshipment Hub Departure", label: "Transshipment Hub Departure" },
    { value: "Flight Delayed", label: "Flight Delayed" },
    { value: "Airline Delay", label: "Airline Delay" },
    { value: "Routing Issue", label: "Routing Issue" },

    // Airport / Hub Processing
    {
      value: "Shipment Arrived at Airport Terminal",
      label: "Shipment Arrived at Airport Terminal",
    },
    { value: "Arrived at Sort Facility", label: "Arrived at Sort Facility" },
    { value: "Arrived at Destination Country", label: "Arrived at Destination Country" },
    { value: "Arrived at Destination Hub", label: "Arrived at Destination Hub" },
    {
      value: "Sorting at Destination Facility",
      label: "Sorting at Destination Facility",
    },
    {
      value: "Assigned to Delivery Branch",
      label: "Assigned to Delivery Branch",
    },
    {
      value: "Outbound from Delivery Facility",
      label: "Outbound from Delivery Facility",
    },

    // Customs
    { value: "Customs Clearance Started", label: "Customs Clearance Started" },
    {
      value: "Under Customs Examination",
      label: "Under Customs Examination",
    },
    {
      value: "Awaiting Customs Documentation",
      label: "Awaiting Customs Documentation",
    },
    {
      value: "Awaiting Import Duty Payment",
      label: "Awaiting Import Duty Payment",
    },
    { value: "Customs Hold", label: "Customs Hold" },
    { value: "Customs Released", label: "Customs Released" },
    { value: "Clearance Completed", label: "Clearance Completed" },

    // Delivery
    { value: "Out for Delivery", label: "Out for Delivery" },
    { value: "Delivery Attempted", label: "Delivery Attempted" },
    { value: "Delivery Rescheduled", label: "Delivery Rescheduled" },
    { value: "Address Issue", label: "Address Issue" },
    {
      value: "Consignee Not Available",
      label: "Consignee Not Available",
    },
    { value: "Delivery Failed", label: "Delivery Failed" },
    { value: "Delivery Refused", label: "Delivery Refused" },

    // Delivered
    { value: "Delivered", label: "Delivered" },
    {
      value: "Delivered to Consignee",
      label: "Delivered to Consignee",
    },
    {
      value: "Delivered – Signature Obtained",
      label: "Delivered – Signature Obtained",
    },
    {
      value: "Delivered to Neighbor / Reception",
      label: "Delivered to Neighbor / Reception",
    },
    {
      value: "Proof of Delivery (POD) Uploaded",
      label: "Proof of Delivery (POD) Uploaded",
    },

    // Payment / Compliance
    { value: "COD Pending", label: "COD Pending" },
    { value: "Duty / Tax Unpaid", label: "Duty / Tax Unpaid" },
    { value: "Payment Confirmed", label: "Payment Confirmed" },
    { value: "Invoice Required", label: "Invoice Required" },
    { value: "KYC Pending", label: "KYC Pending" },
    { value: "Compliance Hold", label: "Compliance Hold" },

    // Exception / Return
    { value: "Shipment on Hold", label: "Shipment on Hold" },
    {
      value: "Returned to Origin (RTO)",
      label: "Returned to Origin (RTO)",
    },
    { value: "Return Initiated", label: "Return Initiated" },
    { value: "Return in Transit", label: "Return in Transit" },
    { value: "Return Delivered", label: "Return Delivered" },
    { value: "Lost in Transit", label: "Lost in Transit" },
    { value: "Damaged", label: "Damaged" },
    { value: "Shipment Cancelled", label: "Shipment Cancelled" },
  ];
    useEffect(() => {
        console.log(formData);
    }, [formData])
    const handleDateChange = (date, field) => {
        setFormData({ ...formData, [field]: date });
    };
    const fetchData = async (endpoint, setData) => {
        try {
            const response = await getApi(endpoint);
            setData(Array.isArray(response.data) ? response.data : []);
        } catch (err) {
            console.error('Fetch Error:', err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        console.log(today.toISOString().slice(11, 16), "+", today.toLocaleTimeString().slice(0, 5));
        fetchData(`/Master/GetInterDomestic?Product_Type=International`, setGetCity);

    }, []);


    const resetForm = () => {
        setFormData((prev) => ({
            ...prev,
            toDate: today,
            fromDest: '',
            toDest: '',
            time: time,
            status: "",

        }))
    }
    const formatTimeAMPM = (timeStr) => {
        if (!timeStr) return "";
        const [hours, minutes] = timeStr.split(":").map(Number);
        const ampm = hours >= 12 ? "PM" : "AM";
        const hours12 = hours % 12 || 12;
        return `${hours12}:${minutes.toString().padStart(2, "0")} ${ampm}`;
    };

    const formatExcelDateForBackend = (value) => {
        if (!value) return "";
        if (value instanceof Date && !isNaN(value)) {
            return `${String(value.getDate()).padStart(2, '0')}/${String(value.getMonth() + 1).padStart(2, '0')}/${value.getFullYear()}`;
        }
        return "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!docket) {
      return Swal.fire(
        {
          icon: "warning",
          title: "Empty",
          text: `Enter Awb No`,
        }
      )
    }
        if (docket === fetched) {
            return Swal.fire(
                {
                    icon: "warning",
                    title: "Status already here",
                    text: `Docket ${docket}' status already fetched`,
                }
            )
        }
        try {
            const res = await getApi(`/DocketBooking/GetStatusDetails?DocketNo=${docket}`);
            if (res.status === 1 && Array.isArray(res.data) && res.data.length > 0) {
                setStatus(res.data);
                setFetched(docket);
                console.log(res.data);
                Swal.fire({
                    icon: 'success',
                    title: 'Status Found',
                    text: res.message,
                });
            } else {
                setStatus([]);
                Swal.fire({
                    icon: 'warning',
                    title: 'No Status Found',
                    text: 'No status available for this Docket.',
                    showConfirmButton: true,
                });
            }
        } catch (error) {
            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'API failed or server error occurred.',
            });
        }

    }
    const AddStatus = async (e) => {
        if (!docket) {
            return Swal.fire({
                icon: 'warning',
                title: 'Missing Docket No',
                text: 'Please fill docket No.',
                confirmButtonText: 'OK',
            });
        }
        e.preventDefault();
        try {
            const queryParams = new URLSearchParams({
                docketNo: docket,
                delvDt: formatExcelDateForBackend(formData.toDate),
                delvTime: formatTimeAMPM(formData.time),
                destinationCode: formData.fromDest,
                destinationName: formData.toDest ? getCity.find((city) => city.City_Code === formData.toDest)?.City_Name : "",
                status: formData.status
            });

            const res = await postApi(`/DocketBooking/StatusEntry?${queryParams.toString()}`, {}); // empty body
            console.log("POST response", res);

            if (res.status === 1) {
                Swal.fire({ icon: 'success', title: 'Status Added', text: res.message });
                resetForm();
                const getRes = await getApi(`/DocketBooking/GetStatusDetails?DocketNo=${docket}`);
                if (getRes.status === 1) setStatus(getRes.data);
            } else {
                Swal.fire({ icon: 'warning', title: 'Failed', text: res.message });
            }

        } catch (error) {
            console.log(error);
            setStatus([]);
            Swal.fire({ icon: 'error', title: 'Error', text: 'API failed' });
        }
    };
    const delStatus = async (id) => {
        console.log(id);

        Swal.fire({
            title: 'Are you sure?',
            text: "Do you really want to delete this status entry? This action cannot be undone.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await postApi(`/DocketBooking/StatusEntryDelete?id=${id}`);
                    if (res.success) {
                        Swal.fire('Deleted!', res.message, 'success');
                        const newList = status.filter((data) => data.ID !== id);
                        setStatus(newList);
                        resetForm();
                    } else {
                        Swal.fire('Error', res.message, 'error');
                    }
                } catch (err) {
                    Swal.fire('Error', 'Failed to delete status.', 'error');
                }
            }
        });
    };


    return (
        <>

            <div className="container1">
                <form className="order-form" onSubmit={handleSubmit} style={{ backgroundColor: "#f2f4f3" }}>
                    <div className="order-fields" style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                        <div className="input-field" style={{ width: "180px" }}>
                            <label htmlFor="">Docket No</label>
                            <input type="text" placeholder="Enter Docket No" value={docket} onChange={(e) => setDocket(e.target.value)} />
                        </div>
                        <div className="bottom-buttons" style={{ marginTop: "27px", marginLeft: "-1px", width: "60px" }}>
                            <button type="submit" className="ok-btn">Find</button>
                        </div>
                    </div>
                </form>

                {/*<div className="addNew">
                    <button className='add-btn' onClick={() => { setModalIsOpen(true); setModalData({ code: '', name: '' }) }}>
                        <i className="bi bi-plus-lg"></i>
                        <span>ADD NEW</span>
                    </button>

                    <div className="dropdown">
                        <button className="dropbtn"><i className="bi bi-file-earmark-arrow-down"></i> Export</button>
                        <div className="dropdown-content">
                            <button onClick={handleExportExcel}>Export to Excel</button>
                            <button onClick={handleExportPDF}>Export to PDF</button>
                        </div>
                    </div>

                    <div className="search-input">
                        <input className="add-input" type="text" placeholder="search" />
                        <button type="submit" title="search">
                            <i className="bi bi-search"></i>
                        </button>
                    </div>
                </div>*/}

                <div className='table-container'>
                    <table className='table table-bordered table-sm tableSize'>
                        <thead className='table-info body-bordered table-sm'>
                            <tr>
                                
                                <th scope="col">Activity Date</th>
                                <th scope="col">Activity Time</th>
                                <th scope="col">From City</th>
                                <th scope="col">To City</th>
                                <th scope="col">Activity</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody className='table-body'>
                            <tr>
                                
                                <td style={{ width: "130px" }}><DatePicker
                                    portalId="root-portal"
                                    selected={formData.toDate}
                                    onChange={(date) => handleDateChange(date, "toDate")}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control form-control-sm custom-datepicker"
                                /></td>
                                <td style={{ width: "130px" }}>
                                    <input className="form-control"
                                        style={{ height: "35px" }}
                                        type="time" value={formData.time} onChange={(e) => { setFormData({ ...formData, time: e.target.value }) }} />
                                </td>
                                <td><Select
                                    options={getCity.map(city => ({
                                        value: city.City_Code,   // adjust keys from your API
                                        label: city.City_Name
                                    }))}
                                    value={
                                        formData.fromDest
                                            ? { value: formData.fromDest, label: getCity.find(c => c.City_Code === formData.fromDest)?.City_Name || "" }
                                            : null
                                    }
                                    onChange={(selectedOption) => {
                                        console.log(selectedOption);
                                        setFormData({
                                            ...formData,
                                            fromDest: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    }
                                    placeholder="Select City"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                    styles={{
                                        placeholder: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            width: '100px'
                                        }),
                                        input: (base) =>
                                        ({
                                            ...base,
                                            width: "100px",
                                        })
                                        ,
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                    }}
                                /></td>
                                <td><Select
                                    options={getCity.map(city => ({
                                        value: city.City_Code,   // adjust keys from your API
                                        label: city.City_Name
                                    }))}
                                    value={
                                        formData.toDest
                                            ? { value: formData.toDest, label: getCity.find(c => c.City_Code === formData.toDest)?.City_Name || "" }
                                            : null
                                    }
                                    onChange={(selectedOption) =>
                                        setFormData({
                                            ...formData,
                                            toDest: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    placeholder="Select City"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                    styles={{
                                        placeholder: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            width: '100px'
                                        }),
                                        input: (base) =>
                                        ({
                                            ...base,
                                            width: "100px",
                                        })
                                        ,
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                    }}
                                /></td>
                                <td>
                                   <Select
                      options={shipmentStatusOptions}
                      value={shipmentStatusOptions.find(
                        (opt) => opt.value === formData.status
                      )}
                      onChange={(selectedOption) =>
                        setFormData({ ...formData, status: selectedOption?.value })
                      }
                      placeholder="Select Status"
                      classNamePrefix="blue-selectbooking"
                      className="blue-selectbooking"
                      menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                      styles={{
                        placeholder: (base) => ({
                          ...base,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          width: '100px'
                        }),
                        input: (base) =>
                        ({
                          ...base,
                          width: "100px",
                        })
                        ,
                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                      }}
                    />
                                </td>



                                {/* <td><input type="text" className="form-control" style={{ height: "35px" }} value={formData.status} onChange={(e) => setFormData({ ...formData, status: e.target.value })} /></td> */}
                                <td>
                                    <button className="ok-btn" style={{ width: "60px", height: "30px" }} onClick={AddStatus}>Add +</button>
                                </td>
                            </tr>
                            {status.map((st, index) => (
                                <tr key={st.ID}>
                                    
                                    <td>{st.DelvDt}</td>
                                    <td>{st.DelvTime}</td>
                                    <td>{st.City_Name}</td>
                                    <td>{st.Destination_name}</td>
                                    <td>{st.status}</td>
                                    <td>
                                        <button className='edit-btn' onClick={() => delStatus(st.ID)}>
                                            <i className='bi bi-trash' style={{ fontSize: "18px" }}></i></button>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>

        </>
    );
};
export default NewPodEntry;